import { SvgIcon } from '@dewise-devex/backstage-plugin-mui-uikit-react';
/**
 * Defines the navigation items for the top navigation bar.
 *
 * Dependencies:
 * - Uses components from `@dewise-devex/backstage-plugin-mui-uikit-react` for icons.
 *
 * Example:
 * - "Home" links to the root URL (`/`) and uses the `HomeIcon`.
 * - "Catalog" links to `/catalog` with the `SdkIcon`.
 * - "Tech Docs" links to `/docs` with the `NewsIcon`.
 *
 * @category Navigation
 */
const tabs = [
  {
    title: 'Home',
    icon: SvgIcon.home,
    url: '/',
  },
  {
    title: 'Catalog',
    icon: SvgIcon.sdk,
    url: '/catalog',
  },
  {
    title: 'Tech Docs',
    icon: SvgIcon.news,
    url: '/docs',
  },
];

export default tabs;
